import t0 from "../../assets/Images/t+0.png";
import t1 from "../../assets/Images/t+1.png";
import instant from "../../assets/Images/instant.png";
import instantChange from "../../assets/Images/instantChange.png";
import t0chnage from "../../assets/Images/t0Change.png";
import t1chnage from "../../assets/Images/t1Chnage.png";
import Call_Api from "../Handileapi/Call_api";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";

export const sevices = [
  {
    id: 1,
    name: "Settlements",
    subServiceName: "Bill",
    subService: "Top_Up",
    image: t0,
    imageChange: t0chnage,
    displayText: "Utility: Only Visa - HDFC Working",
  },
  {
    id: 2,
    name: "Settlements",
    subServiceName: "Bill Plus",
    subService: "BILL[PRO]",
    image: instant,
    imageChange: instantChange,
    displayText: "Non Utility: All Cards - No HDFC",
  },
  // {
  //   id: 2,
  //   name: "Settlements",
  //   subServiceName: "Edu",
  //   subService: "PRO[INSTANT]",
  //   image: instant,
  //   imageChange: instantChange,
  //   displayText: "Non Utility: All Cards - NO HDFC",
  // },
  {
    id: 3,
    name: "Settlements",
    subServiceName: "NU 1",
    subService: "PRO[T+1]",
    image: t1,
    imageChange: t1chnage,
    displayText: "Non Utility: All Cards - No HDFC",
  },
  {
    id: 4,
    name: "Settlements",
    subServiceName: "NU (T+0)",
    subService: "PRO[T+0]",
    image: t1,
    imageChange: t1chnage,
    displayText: "Non Utility: HDFC Working",
  },
  {
    id: 5,
    name: "Settlements",
    subServiceName: "Edu",
    subService: "PRO[INSTANT]",
    image: instant,
    imageChange: instantChange,
    displayText: "Education Category",
  },
  // {
  //   name: "Settlements",
  //   subServiceName: "Pro T+0",
  //   subService: "PRO[T+0]",
  //   image: t1,
  //   imageChange: t1chnage,
  // },
];

export const getActiveServices = async (nameOfPage) => {
  const token = await GetWebAccessToken();
  try {
    if (!token) {
      return [];
    }

    const response = await Call_Api(
      "/activeFeatures/get/all",
      "GET",
      {},
      token
    );
    const activeServices = response?.response;

    if (!activeServices || activeServices.length === 0) {
      return [];
    }

    let filtered = [];

    if (nameOfPage == "Receipt") {
      filtered = activeServices.filter(
        (item) =>
          item.serviceName === "Settlements" &&
          item?.subService?.toLowerCase() != "transfer" &&
          item?.subService?.toLowerCase() != "settlements"
      );
    } else {
      filtered = activeServices.filter(
        (item) =>
          item.serviceName === "Settlements" &&
          item.isFeatureEnabled === "Active" &&
          item?.subService?.toLowerCase() != "transfer" &&
          item?.subService?.toLowerCase() != "settlements"
      );
    }

    return filtered;
  } catch (error) {
    console.error("Error while getting active services", error);
    return [];
  }
};

export const getPaidServices = async (page) => {
  const services = await getActiveServices(page);
  return services;
};
